import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/directive/permission'

import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import '@/style/custom.scss'

import VideoPlay from 'vue-video-player';
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VideoPlay,{});

if (process.env.NODE_ENV === 'development') {
  Vue.use(BootstrapVue);
  Vue.use(BootstrapVueIcons);
}
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

console.log(process.env.NODE_ENV);
